/* eslint-disable no-undef */
import React, { Component } from 'react';
import Hoverable from '../../components/hover/hoverable';
import {
  Dimensions,
  Platform,
  Image,
  ScrollView,
  FlatList,
  View,
  Text,
  TouchableOpacity,
  Linking
} from 'react-native';
import styles from '../HomeScreen/styles/style';
import { hocComponentFetcherWithLoader } from '../../components';
import { AppConsumer } from '../../AppContext';
import Leftsidebar from '../InternalComponents/LeftSideBar';
import Loader from '../InternalComponents/loader';
import Topsection from '../InternalComponents/Topsection';
import { getResponsiveStyle } from '../../utils/appUtils';
import TopNav from '../InternalComponents/Topnav';
import TopMobileNav from '../InternalComponents/TopnavMobile';
import Autocomplete from '../../components/customAutoComplete';
import {
  getService,
  AUTH,
  SOURCE,
  getDecrypetedData,
  CSR,
  gettestApi,
  MenuOption,
  getBitlyUrl,
  DeActivateToken
} from '../../network/request/apirequests';
import ApiTag from '../../network/request/apiTags';
import AsyncStorage from '@react-native-community/async-storage';
import {
  ALL_CONSTANTS,
} from '../../constants/displayConstants';
import { data } from 'jquery';
import Modal from '.././userVerification/dob/date';
import IdleTimer from 'react-idle-timer';
import { APP } from '../../constants/textConstants';

function toTitleCase(str) {
  return str?.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

const formatData = (data, numColumns) => {
  const numberOfFullRows = Math.floor(data.length / numColumns);

  let numberOfElementsLastRow = data.length - numberOfFullRows * numColumns;
  while (
    numberOfElementsLastRow !== numColumns &&
    numberOfElementsLastRow !== 0
  ) {
    data.push({ key: `blank-${numberOfElementsLastRow}`, empty: true });
    numberOfElementsLastRow++;
  }

  return data;
};
var isFirefox = typeof InstallTrigger !== 'undefined';
class HomeScreen extends Component {
  constructor(props) {
    super(props);
    const { measure } = props;
    super(props);
    this.makeAPICall = props.makeAPICall;
    this.state = {
      CloseSelectionDropdown: false,
      SelectedDropdownOption: '',
      SearchElements: [],
      leadNo: 'null',
      option: 'Profile Update',
      openMobilelist: false,
      refresh: false,
      data: '',
      searchArray: '',
      loader: false,
      Menuselected: 'Profile Update Requests',
      serviceData: '',
      page: 1,
      blur: false,
      pageArray: '',
      menuType: 'PROFILE',
      menuname: 'Profile',
      selectedPage: 1,
      perPage: 10,
      searchCheck: false,
      serviceCall: false,
      pageCount: '',
      windowHeight: Dimensions.get('window').height,
      windowWidth: Dimensions.get('window').width,
      loading: false,
      ServiceRequests: [],
      isClick: false,
      headerFlag: true,
      isSearch: false,
      machine: false,
      hidemenu: false,
      stateId: 0,
      searchFlag: false,
      searchAll: true,
      sourceType: '',
      homeScreen: true,
      bitlyStatus: false,
      layoutheight: '',
      sidebarlayoutheight: '',
      isIddle: false,
      popUpFlag: false,
      updateFatca: false,
    };
  }

  async componentDidMount() {
    // sessionStorage.setItem("counter", 0);
    window.onbeforeunload = this.cleanUp;
    if (Platform.OS == 'android') {
      this.focusListener = this.props.navigation.addListener('didFocus', () => {
        this.getservicelist(1);
        this.MenuOptionapi();
      });
    }
    
    sessionStorage.setItem('ExternalFlag', false);
    
    let id = 1;
    if (Platform.OS == 'web') {

      const pathName = window.location.pathname;
      switch (true) {
        case pathName.includes(ALL_CONSTANTS.PROFILE_PATH):
          id = 1;
          this.setState({
            hidemenu: true,
            menuname: 'Profile',
            Menuselected: ALL_CONSTANTS.PROFILE_HEADING,
            searchAll: false
          });
          break;
        case pathName.includes(ALL_CONSTANTS.ACCOUNT_PATH):
          id = 2;
          this.setState({ hidemenu: true, menuType: "ACCOUNT", menuname: 'Accounts', Menuselected: ALL_CONSTANTS.ACCOUNT_HEADING, searchAll: false });
          break;
        case pathName.includes(ALL_CONSTANTS.CREDIT_CARD_PATH):
          id = 3;
          this.setState({
            hidemenu: true,
            menuType: "CREDIT",
            menuname: 'Credit Cards',
            Menuselected: ALL_CONSTANTS.CREDIT_CARD_HEADING,
            searchAll: false
          });
          break;
        case pathName.includes(ALL_CONSTANTS.LOAN_PATH):
          id = 4;
          this.setState({ hidemenu: true, menuType: "LOAN", menuname: 'Loans', Menuselected: ALL_CONSTANTS.LOAN_HEADING, searchAll: false });
          break;
        case pathName.includes(ALL_CONSTANTS.DEPOSITS_PATH):
          id = 5;
          this.setState({ hidemenu: true, menuType: 'DEPOSIT', menuname: 'Deposits', Menuselected: ALL_CONSTANTS.DEPOSITS_HEADING, searchAll: false });
          break;
        case pathName.includes(ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH):
          id = 7;
          this.setState({
            hidemenu: true,
            menuType: "INVESTMENT",
            menuname: 'Investment Products',
            Menuselected: ALL_CONSTANTS.INVESTMENT_PRODUCT_HEADING, searchAll: false
          });
          break;
        case pathName.includes(ALL_CONSTANTS.FOREX_PATH):
          id = 8;
          this.setState({ hidemenu: true, menuType: "FOREX", menuname: 'Forex', Menuselected: ALL_CONSTANTS.FOREX_HEADING, searchAll: false });
          break;
        case pathName.includes(ALL_CONSTANTS.ATMDEBIT_PATH):
          id = 9;
          this.setState({ hidemenu: true, menuType: "ATM_DEBIT", menuname: 'Atm/Debit Card', Menuselected: ALL_CONSTANTS.DEBIT_HEADING, searchAll: false });
          break;
        case pathName.includes(ALL_CONSTANTS.OTHERURL_PATH):
          this.setState({ hideOther: false, });
          break;
        default:
          this.setState({ hideOther: true, });
          null;
      }
    }
    this.state.stateId = id;
    let source = new URLSearchParams(window.location.search).get('source');
    let url = window.location.search.split('?')
    let sourceCSR = url[1] ? url[1].split('C-') : ''
    let sourceOther = url[1] ? url[1].split('V-') : ''
    if (sourceCSR[1]) {
      this.state.sourceType = 'csr';
      this.setState({ bitlyStatus: true, headerFlag: true ,appTag:'csr'});
      this.GetcsrRedirectBitly(url[1], sourceCSR[1]);
    } else if (sourceOther[1]) {
      this.state.sourceType = 'vrm';
      this.setState({ bitlyStatus: true, headerFlag: false,appTag:'vrm' });
      this.GetcsrRedirectBitly(url[1], sourceOther[1]);
    } else {
      let EncryptedData = new URLSearchParams(window.location.search).get('params');
      EncryptedData = EncryptedData ? EncryptedData.split(' ').join('+') : '';
      let EncryptedSource = new URLSearchParams(window.location.search).get('sourceId');
      EncryptedSource = EncryptedSource ? EncryptedSource.split(' ').join('+') : '';
      if (EncryptedData === '' || EncryptedData === null) {
        if (Platform.OS === 'web') {
          source = sessionStorage.getItem('sourceName');
          machine = sessionStorage.getItem('machine');
        }
      } else {
        sessionStorage.setItem('source', source);
        let sourceName = sessionStorage.getItem('sourceName');
        sessionStorage.setItem('sourceName', sourceName ? sourceName : source);
        sessionStorage.setItem('EncryptedData', EncryptedData);
        sessionStorage.setItem('EncryptedSource', EncryptedSource);
        sessionStorage.setItem('sourceType', sourceName ? sourceName: source);
        
      }
      if (EncryptedData === '' || EncryptedData === null) {

        this.state.EncryptedData = sessionStorage.getItem('EncryptedData');

      } else {
        this.state.EncryptedData = EncryptedData;
      }
      if (EncryptedSource === '' || EncryptedSource === null) {

        this.state.EncryptedSource = sessionStorage.getItem('EncryptedSource');

      } else {
        this.state.EncryptedSource = EncryptedSource;
      }
      let machine = new URLSearchParams(window.location.search).get('machine');
      if (machine === 'ATM') {
        await this.setState({ machine: true, perPage: 6 }, () => {
        });
        sessionStorage.setItem('machine', 'true');
      }
      if (source) {
        this.state.sourceType = sessionStorage.getItem('sourceName');
        this.setState({ headerFlag: false });
      }
      if (Platform.OS === 'web') {
        source = sessionStorage.getItem('source');
        machine = sessionStorage.getItem('machine');
      }
      if (source) {
        this.setState({ headerFlag: false, });
      }
      this.setState({ loader: true });
      this.props.navigation.state.params = {};

      let measure = this.props.measure;
      if (machine === 'true') {
        await this.setState({ machine: true, perPage: 6 }, () => {
        });
      } else {
        if (measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') {
          this.setState({ perPage: 8 });
        } else if (measure === 'XXHDPI') {

          this.setState({ perPage: 16 });
        } else {

          this.setState({ perPage: 10 });
        }
      }
      // this.getservicelist(id);
      // this.MenuOptionapi();
      if (source) {
        this.GetDecodedData();
      } else {
        this.getservicelist(id);
      }
      this.MenuOptionapi();
    }
  }
  removeToken = async () => {
    let userToken;
    if (Platform.OS === 'web') {
      userToken = sessionStorage.getItem('token');
    } else {
      userToken = await AsyncStorage.getItem('token');
    }
    var fieldData = {
      token: userToken,
    };
    this.makeAPICall(
      DeActivateToken(fieldData, AUTH),
      this.onDataReceived,
      this.onError
    );
  };
  cleanUp = (e) => {
    let userToken = sessionStorage.getItem('token');
    userToken !== null && this.removeToken();
    return undefined; //Gecko + Webkit, Safari, Chrome etc.
  }
  toggleReadmore =() => {
    this.setState({isReadMore:!this.state.isReadMore})
  }
  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.cleanUp)
  }

  GetBitly = (Id, UniqueID) => {

    var that = this;
    this.setState({ UniqueID: UniqueID, refID: Id })
    var fieldData = {
      "uniqueId": Id
    };
    this.makeAPICall(
      getBitlyUrl(fieldData, SOURCE),
      this.onDataReceived,
      this.onError
    );
  };
  GetcsrRedirectBitly = (Id, UniqueID) => {
    this.setState({ UniqueID: UniqueID, refID: Id })
    var that = this;
    var fieldData = {
      "uniqueId": Id
    };
    this.makeAPICall(
      getBitlyUrl(fieldData, AUTH),
      this.onDataReceived,
      this.onError
    );
  };
  GetDecodedData = () => {
    var that = this;
    var fieldData = {
      "encryptData": '',
      'encryptSource': this.state.EncryptedSource,
      "sourceName": this.state.sourceType.toUpperCase(),
    };
    this.makeAPICall(
      getDecrypetedData(fieldData, SOURCE),
      this.onDataReceived,
      this.onError
    );
  };
  MenuOptionapi = () => {
    var that = this;
    var fieldData = {};
    this.makeAPICall(MenuOption({}, CSR), this.onDataReceived, this.onError);
  };
  getservicelist = id => {
    var that = this;
    var fieldData = {
      number: this.state.stateId,
      dynamicSearch: String(this.state.searchFlag)
    };
    this.makeAPICall(
      getService(fieldData, CSR),
      this.onDataReceived,
      this.onError
    );
  };
  getencrypt = id => {
    var that = this;
    var fieldData = {
      number: 1
    };
    this.makeAPICall(
      gettestApi(fieldData, AUTH),
      this.onDataReceived,
      this.onError
    );
  };

  onDataReceived = async response => {
    if (ApiTag.GETSERVICE == response.tag) {
      let array = [];
      if (response.data.data.length > 0) {
        for (let i = 0; i < response.data.data.length; i += 1) {
          if (response.data.data[i]['images'] === null) {
            var ServiceImages = require('../../assets/images/icon_email.png');
          } else {
            var ServiceImages = response.data.data[i]['images'];
          }
          let dataArray = [];
          Object.keys(response.data.data[i]).map((key, val, item) => {
            dataArray = {
              id: response.data.data[i]['serviceId'],
              title: response.data.data[i]['servicename'],
              orderid: response.data.data[i]['orderid'],
              serviceType: response.data.data[i]['serviceType'],
              images: ServiceImages,
              dynamicStatus: response.data.data[i]['dynamicStatus'],
              dynamicMessage: response.data.data[i]['message'],
              menuname: response.data.data[i]['menuname'],
              dynamicMenuType: response.data.data[i]['menuType'],
              keywordSearch: response.data.data[i]['keywordSearch'],
              displayName: response.data.data[i]['displayMessage'],
              uploadFlag: response.data.data[i]['uploadFlag'],
              uploadMessage: response.data.data[i]['uploadMessage'],
              timeFlag: response.data.data[i]['timeFlag'],
              items: response.data.data[i],
              gridFlag:response.data.data[i]['gridFlag'],
              debitFlag:response.data.data[i]['debitFlag'],

            };
          });
          array.push(dataArray);
        }
      }

      array.sort(function (a, b) {
        return a.orderid - b.orderid;
      });
      if (this.state.serviceCall === true) {
        this.setState({
          searchArray: array,
          loader: false,
          searchCheck: true,
          serviceCall: false
        });
      } else {
        this.setState({ data: array, loader: false });
        if (this.state.searchCheck) {
          this.state.serviceCall = false;
        } else {
          this.state.serviceCall = true;
        }
        this.calculate();
        if (this.state.searchCheck === false) {
          if (this.state.searchAll == true) {
            this.setState({ stateId: 0 });
            this.getservicelist(this.state.stateId);
          } else {
            this.getservicelist(this.state.stateId);
          }
          //this.setState({ searchFlag: true });
        }
      }
    } else if (ApiTag.Menu_Option == response.tag) {
      if (response.data.status === 200) {
        var config = this.state.ServiceRequests;
        let array = [];
        for (var i = 0; i < response.data.data.length; i++) {
          if (i === 0) {
            var serviceOnloadselect = true;
          } else {
            var serviceOnloadselect = false;
          }
          let dataArray = [];

          var imageslink;
          if (response.data.data[i].images === null) {
            imageslink = '';
          } else {
            imageslink = response.data.data[i].images;
          }
          Object.keys(response.data.data[i]).map((key, val, item) => {
            if (
              this.state.hideOther != false &&
              response.data.data[i].menuType === 'OTHERS'
            ) {
              array.splice(i, 1);
            } else {
              dataArray = {
                menuid: response.data.data[i].menuid,
                servicename: response.data.data[i].menuname,
                menuname: response.data.data[i].menuname,
                menuType: response.data.data[i].menuType,
                menuHeader: response.data.data[i].menuHeader,
                imageIcons: imageslink,
                text: response.data.data[i].text,
                color: response.data.data[i].colour,
                orderid: response.data.data[i].orderid,
                serviceimage: '',
                serviceSelected: serviceOnloadselect,
                url: response.data.data[i].url,
              };
            }
          });
          array.push(dataArray);
        }
        this.setState({ ServiceRequests: array });
      } else {
        this.props.navigation.state.params.ErrormessageText =
          ALL_CONSTANTS.PROCESS_REQUEST;
        this.props.navigation.navigate(
          'errorpage',
          this.props.navigation.state.params
        );
      }
    } else if (ApiTag.GETDECRYPTEDDATA == response.tag) {
      if (Platform.OS === 'web') {
        test = sessionStorage.setItem('sourceKey', response.data.data.source);
        userid1 = sessionStorage.setItem('userid', response.data.data.userid ?? null);
      } else {
        test = await AsyncStorage.setItem('sourceKey', response.data.data.source);
        userid1 = sessionStorage.setItem('userid', response.data.data.userid ?? null);
      }
      this.getservicelist(this.state.stateId);
    }  else if (ApiTag.GETBITLY == response.tag) {
      this.setState({ bitlyStatus: false });
      this.props.navigation.state.params = {};
      this.props.navigation.state.params.headerFlag = this.state.headerFlag;
      this.props.navigation.state.params.sourceType =
        response.data.data.SOURCE_TYPE;
      this.props.navigation.state.params.UniqueID = this.state.UniqueID;
      this.props.navigation.state.params.refID = this.state.refID;
      this.props.navigation.state.params.appTag = this.state.appTag;
      this.props.navigation.navigate(
        'ConfirmCustomer',
        this.props.navigation.state.params
      );
    }
  };

  onError = err => {
    var that = this;
    if (ApiTag.GETSERVICE == err.tag) {
    } else if (ApiTag.Menu_Option == err.tag) {
    } else if (ApiTag.GETBITLY == err.tag) {
      this.setState({ bitlyStatus: false })
      // window.location.href = `${window.location.origin}/servicing/index.html`;
    }
  };
  calculate(item) {
    let array = [];
    let count = this.state.data.length;
    let i = count / this.state.perPage;
    let perPage = this.state.perPage;
    let valid = Number.isInteger(i);
    let page = '';
    if (valid === false) {
      page = Math.floor(i);

      page = page + 1;
    } else {
      page = i;
    }
    for (let i = 0; i < page; i += 1) {
      let dataArray = {
        id: i + 1
      };
      array.push(dataArray);
    }
    let firstRow = '';
    firstRow = this.state.data.slice(0, perPage);
    this.setState({ pageArray: array, pageCount: page, serviceData: firstRow });
  }

  onSubmit = async (
    item,
    title,
    type,
    dynamic,
    message,
    menuType,
    servicename,
    displayName
  ) => {

    // * handle the redirection to flutter flow
    // * create a URL with menuType, serviceType, serviceName, serviceId
    const flutterUrl = new URL(`${window.location.protocol}//${window.location.host}/servicingFF/`)
    flutterUrl.searchParams.set('serviceType', item.serviceType);

    sessionStorage.setItem('serviceItem', JSON.stringify(item))

    // * redirect if redirectionFlag is true
    if(item?.items?.flutterRedirectionFlag){
        window.location.href = flutterUrl.toString();
        return; // * prevent navigating to verification page
    }

    var d = new Date();
    var minute = d.getMinutes();
    if (
      item.timeFlag &&
      (d.getHours() < 9 || ((d.getHours() >= 17 && minute >= 30) || (d.getHours() >= 18)))
    ) {
      this.setState({
        timeFlag: true,
        isVisible: true,
        timeMessage:
          data.serviceType === 'CANCEL_ECS_MANDATE' ? ALL_CONSTANTS.PROCESS_TIMING : ALL_CONSTANTS.PROCESS_TIMINGS,
      });
      return;
    }
    if (item.items.authenticationFlag === false && item.items.redirectionFlag) {
      if (Platform.OS == 'web') {
        window.open(item.items.redirectionUrl, target = "_blank");
      }
      else {
        Linking.openURL(item.items.redirectionUrl, target = "_blank");
      }
      return;
    }

    this.setState({ isClick: true });
    this.props.navigation.state.params = {};
    this.props.navigation.state.params.flow = title;
    this.props.navigation.state.params.serviceType = type;
    this.props.navigation.state.params.servicename = title;
    this.props.navigation.state.params.serviceDynamic = dynamic;
    this.props.navigation.state.params.menuType = this.state.menuType;
    this.props.navigation.state.params.menuname = this.state.menuname;
    this.props.navigation.state.params.serviceMessageForNoDynamic = message;
    this.props.navigation.state.params.searchArray = this.state.searchArray;
    this.props.navigation.state.params.flag = true;
    this.props.navigation.state.params.displayName = displayName;
    this.props.navigation.state.params.headerFlag = this.state.headerFlag;
    this.props.navigation.state.params.orderid = item.id;
    this.props.navigation.state.params.item = item;
    this.props.navigation.state.params.serviceId = item.id;
    this.props.navigation.state.params.EncryptedData = this.state.EncryptedData;
    this.props.navigation.state.params.EncryptedSource = this.state.EncryptedSource;
    this.props.navigation.state.params.sourceType = this.state.sourceType;
    // if (Platform.OS === 'web') {
    //   sessionStorage.setItem('flag', 'true');
    // } else {
    //   await AsyncStorage.setItem('flag', 'true');
    // }
    if (this.state.headerFlag) {
      // if (menuType === OVERDUETYPE) {
      // this.props.navigation.navigate(
      //   'Options',
      //   this.props.navigation.state.params
      // );
      // }

      // else {
      this.props.navigation.state.params.account = 'false';
      this.props.navigation.state.params.mobile = 'true';
      this.props.navigation.state.params.firstpage = 'true';
      this.props.navigation.state.params.shortName1 = 'mob';
      this.props.navigation.state.params.shortName2 = 'pan';

      let menu = this.state.menuname === 'Accounts' ? '' : this.state.menuname + ' - ';
      // this.props.navigation.state.params.subHeading = menu +
      //   displayName;
      this.props.navigation.state.params.subHeading = displayName;
      this.props.navigation.state.params.Optionselected2 = ALL_CONSTANTS.PAN_NUMBER_CONST;
      if (item.items.popUpFlag) {
        this.setState({ isVisible: true, popUpFlag: true, uploadMessage: item.items.popUpMessage[0].note, hyperLinkText: item.items.popUpMessage[0].hyperlink }, () => {
        });
      } else {
        this.setState({ popUpFlag: false })
        this.props.navigation.navigate(
          'Verification',
          this.props.navigation.state.params
        );
      }
    } else {
      if (item.uploadFlag) {
        this.setState({ isVisible: true, popUpFlag: false, uploadMessage: item.uploadMessage });
      } else if (item.items.popUpFlag) {
        this.setState({ isVisible: true, popUpFlag: true, uploadMessage: item.items.popUpMessage[0].note, hyperLinkText: item.items.popUpMessage[0].hyperlink }, () => {
        }
        );
      } else {
        this.props.navigation.navigate(
          'verifyUser',
          this.props.navigation.state.params
        );
      }
    }

  };
  onCancel = () => {
    this.setState({
      isVisible: false,
      blur: false,
      SearchElements: '',
      SelectedDropdownOption: ''
    });
  };
  onAgree = () => {
    if (this.state.headerFlag) {
      this.props.navigation.navigate(
        'Verification',
        this.props.navigation.state.params
      );
    } else {
      this.setState({ isVisible: false, timeFlag: false });
      this.props.navigation.navigate(
        'verifyUser',
        this.props.navigation.state.params
      );
    }
  };

  renderItem = ({ item, index }) => {
    const { measure } = this.props;
    if (item.empty === true) {
      return (
        <View
          style={[
            styles.serviceBoxPadding,
            { flex: 1, backgroundColor: 'transparent', justifyContent: this.state.machine != false ? 'space-around' : null },
            styles[getResponsiveStyle('serviceBoxPadding', measure)]
          ]}
        >
          <TouchableOpacity
            onPress={() =>
              this.onSubmit(
                item.title,
                item.serviceType,
                item.dynamicStatus,
                item.dynamicMessage,
                item.dynamicMenuType,
                item.servicename
              )
            }
          >
            <Text
              style={[
                styles.serviceText,
                styles[getResponsiveStyle('serviceText', measure)]
              ]}
            >
              {item.Title}
            </Text>
          </TouchableOpacity>
        </View>
      );
    }
    return (
      <View
        style={[
          styles.serviceBoxPadding,
          { flex: 1 },
          styles[getResponsiveStyle('serviceBoxPadding', measure)]
        ]}
      >
        <TouchableOpacity
          onPress={() =>
            this.onSubmit(
              item,
              item.title,
              item.serviceType,
              item.dynamicStatus,
              item.dynamicMessage,
              item.dynamicMenuType,
              item.servicename,
              item.displayName
            )
          }
          style={
            measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI'
              ? [
                {
                  height: '100%',
                  borderRadius: 2,
                  elevation: Platform.OS === 'web' ? 5 : 2,
                  //padding: '1%',
                  // justifyContent: 'center',
                  // alignItems: 'center',
                  shadowColor: 'grey',
                  shadowOffset: {
                    width: 0,
                    height: 2
                  },
                  shadowOpacity: 0.2,
                  borderBottomRightRadius: 6,
                  shadowRadius: 15,
                  backgroundColor: '#ffb571',
                }
              ]
              : [
                styles.serviceBox,
                styles[getResponsiveStyle('serviceBox', measure)]
              ]
          }
        >
          <View
            style={
              measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI'
                ? [
                  styles.serviceImageView,
                  styles[getResponsiveStyle('serviceImageView', measure)]
                ]
                : [
                  styles.serviceImageView,
                  styles[getResponsiveStyle('serviceImageView', measure)]
                ]
            }
          >
            {`${item.images}`.includes('http') ? (
              <Image
                style={[
                  styles.serviceImageStyle,
                  styles[getResponsiveStyle('serviceImageStyle', measure)]
                ]}
                source={{ uri: item.images }}
              />
            ) : (
              <Image
                style={[
                  styles.serviceImageStyle,
                  styles[getResponsiveStyle('serviceImageStyle', measure)]
                ]}
                source={item.images}
              />
            )}
          </View>
          <Hoverable>
            {(isHovered) => (
              <View
                style={[
                  styles.serviceTextView,
                  styles[getResponsiveStyle('serviceTextView', measure)]
                ]}
              >
                {isHovered ? (
                  <Text
                    style={[
                      styles.serviceText,
                      { color: '#101d6c' },
                      styles[getResponsiveStyle('serviceText', measure)]
                    ]}
                  >
                    {item.title}
                  </Text>)
                  : <Text
                    style={[
                      styles.serviceText,
                      styles[getResponsiveStyle('serviceText', measure)]
                    ]}
                  >
                    {item.title}
                  </Text>}

              </View>

            )}
          </Hoverable>
          <View style={{ alignItems: 'flex-end', }}>
            <View style={[
              styles.homescreenService,
              styles[getResponsiveStyle('homescreenService', measure)]
            ]}>

              <Image
                style={[
                  styles.serviceImageStyleArrow, { padding: 5 },
                  styles[getResponsiveStyle('serviceImageStyleArrow', measure)]
                ]}
                source={require('../../assets/images/serviceArrow@2x.png')}
              />
            </View>

          </View>
        </TouchableOpacity>
      </View>

    );
  };
  renderCircle = ({ item, index }) => {
    const { measure } = this.props;
    return (
      <View>
        <View
          style={
            item.id === this.state.selectedPage
              ? [
                styles.selectedcircleBox,
                styles[getResponsiveStyle('selectedcircleBox', measure)]
              ]
              : [
                styles.circleBox,
                styles[getResponsiveStyle('circleBox', measure)]
              ]
          }
        ></View>
      </View>
    );
  };

  viewMore = () => {
    let tot = this.state.pageCount;
    let page = this.state.selectedPage;
    let perPage = this.state.perPage;
    page = page + 1;
    if (page > tot) {
      page = this.state.selectedPage;
    } else {
      let firstRow = this.state.data.slice(
        perPage * (page - 1),
        perPage * page
      );
      this.setState({ serviceData: firstRow, refresh: !this.state.refresh });
    }
    this.setState({ selectedPage: page });
  };
  viewless = () => {
    let tot = this.state.pageCount;
    let page = this.state.selectedPage;
    let perPage = this.state.perPage;
    if (page === 1) {
      page = 1;
    } else {
      page = page - 1;
    }

    if (page === 1) {
      let firstRow = this.state.data.slice(0, perPage);
      this.setState({ serviceData: firstRow, refresh: !this.state.refresh });
      page = 1;
    } else {
      let firstRow = this.state.data.slice(
        perPage * (page - 1),
        perPage * page
      );
      this.setState({ serviceData: firstRow, refresh: !this.state.refresh });
    }
    this.setState({ selectedPage: page });
  };

  OnServiceRequestsButtonPress = async (
    item,
    menuType,
    index,
    menuHeader,
    menuname,
  ) => {
    if (menuType === ALL_CONSTANTS.OVERDUETYPE) {
      ///display constant
      this.props.navigation.state.params = {};
      this.props.navigation.state.params.menuType = menuType;
      this.props.navigation.state.params.menuname = 'Request';
      this.props.navigation.state.params.serviceType = 'Over Due';
      this.props.navigation.state.params.displayName = 'Over Due';
      this.props.navigation.state.params.servicename = 'OverDue';
      this.props.navigation.state.params.serviceId = '15';
      this.props.navigation.state.params.shortName1 = 'mob';
      this.props.navigation.state.params.shortName2 = 'pan';
      this.props.navigation.state.params.searchArray = this.state.searchArray;
      this.props.navigation.state.params.headerFlag = this.state.headerFlag;
      this.props.navigation.state.params.account = 'false';
      this.props.navigation.state.params.mobile = 'true';
      this.props.navigation.state.params.firstpage = 'true';
      this.props.navigation.state.params.Optionselected2 = ALL_CONSTANTS.PAN_NUMBER_CONST;
      //this.props.navigation.state.params.subHeading = data.displayName;
      if (Platform.OS === 'web') {
        sessionStorage.setItem('flag', 'true');
      } else {
        await AsyncStorage.setItem('flag', 'true');
      }
      // this.props.navigation.navigate(
      //   'Cardekholastscreen',
      //   this.props.navigation.state.params
      // );
      // this.props.navigation.navigate(
      //   'Options',
      //   this.props.navigation.state.params
      // );
      this.props.navigation.navigate(
        'NewDueVerification',
        this.props.navigation.state.params
      );
    } //for Overdue options

    var config = this.state.ServiceRequests;
    var url = config[index].url;
    var id = config[index].menuid;
    for (let i = 0; i < config.length; i++) {
      if (config[i].servicename === item) {
        config[i].serviceSelected = true;
        if (menuType === 'OTHERS') {
          if (Platform.OS == 'web') {
            window.open(url, "_blank");
          }
          else {
            Linking.openURL(url, "_blank");
          }
        }
      } else {
        config[i].serviceSelected = false;
      }
    }
    await this.setState({
      ServiceRequests: config,
      menuType: menuType,
      menuname: menuname,
      openMobilelist: false,
      selectedPage: 1,
      menuType: menuType,
      Menuselected: menuHeader,
      stateId: id,
      isSearch: true, menuload: true
    });
    if (menuType != 'OTHERS') {
      this.getservicelist(id);
    } else {
      // this.timerHandle = setTimeout(() => {
      //   this.setState({ loading: false, loader: false, });
      //   window.location.href = `${domainName}/servicing/index.html`;
      //   this.timerHandle = 0;
      // }, 3000);

      this.redirect();
    }
  };

  RendermenuBar = openMobilelist => {
    this.setState({ openMobilelist: openMobilelist });
  };

  searchOptionChange = (text) => {
    this.setState({ isSearch: true });
    var newText = text.toUpperCase();
    if (text.length >= 3) {
      var configure = [];
      configure = this.state.searchArray;
      var config = this.state.SearchElements;
      var maincityCar = [];
      var valuestoDisplay = [];
      for (var i = 0; i < configure.length; i++) {
        if (configure[i].keywordSearch && configure[i].keywordSearch !== null) {
          var inputtext = configure[i].keywordSearch.toUpperCase();
          for (var j = 0; j < inputtext.length; j++) {
            if (inputtext.length > 0) {
              var n = inputtext.includes(newText);
            } else {
              var n = -1;
            }
            if (n === true) {
              let disp = {
                optionname: configure[i].title,
                serviceId: configure[i].id,
                images: configure[i].images,
                dynamicMenuType: configure[i].dynamicMenuType,
                menuname: configure[i].menuname,
                serviceType: configure[i].serviceType,
                dynamicStatus: configure[i].dynamicStatus,
                displayName: configure[i].displayName,
                timeFlag: configure[i].timeFlag,
                dualFlag: configure[i].dualFlag,
                items: configure[i].items,
                gridFlag: configure[i].gridFlag,
                debitFlag:configure[i].debitFlag

              };
              valuestoDisplay.push(disp);
            }
            maincityCar = Array.from(
              new Set(valuestoDisplay.map((a) => a.optionname))
            ).map((id) => {
              return valuestoDisplay.find((a) => a.optionname === id);
            });
          }
        }
        let valid = false;
        if (maincityCar.length > 0) {
          valid = true;
        }
        let sort = maincityCar.sort((a, b) =>
          a.optionname > b.optionname ? 1 : b.optionname > a.optionname ? -1 : 0
        );
        this.setState({
          SearchElements: maincityCar,
          CloseSelectionDropdown: false,
          blur: valid,
        });
      }
    } else if (text.length === 0 || text.length < 3) {
      this.setState({
        CloseSelectionDropdown: true,
        SearchElements: '',
        blur: false,
      });
    }
    this.setState({ SelectedDropdownOption: newText });
  };
  searchOptionChangeVRM = (text) => {
    this.setState({ isSearch: true })
    var newText = text.toUpperCase();
    if (text.length >= 3) {
      var configure = [];
      configure = this.state.searchArray;
      var config = this.state.SearchElements;
      var maincityCar = [];
      var valuestoDisplay = [];
      for (var i = 0; i < configure.length; i++) {
        if (configure[i].keywordSearch && configure[i].keywordSearch !== null) {
          var inputtext = configure[i].keywordSearch.toUpperCase();
          for (var j = 0; j < inputtext.length; j++) {
            if (inputtext.length > 0) {
              var n = inputtext.includes(newText);
            } else {
              var n = -1;
            }
            if (n === true) {
              let disp = {
                optionname: configure[i].title,
                serviceId: configure[i].id,
                images: configure[i].images,
                dynamicMenuType: configure[i].dynamicMenuType,
                menuname: configure[i].menuname,
                serviceType: configure[i].serviceType,
                dynamicStatus: configure[i].dynamicStatus,
                displayName: configure[i].displayName,
                items: configure[i].items,
                gridFlag:configure[i].gridFlag,
                debitFlag:configure[i].debitFlag,
              };
              valuestoDisplay.push(disp);
            }
            maincityCar = Array.from(
              new Set(valuestoDisplay.map(a => a.optionname))
            ).map(id => {
              return valuestoDisplay.find(a => a.optionname === id);
            });
          }
        }
        let valid = false;
        if (maincityCar.length > 0) {
          valid = true;
        }
        let sort = maincityCar.sort((a, b) =>
          a.optionname > b.optionname ? 1 : b.optionname > a.optionname ? -1 : 0
        );
        this.setState({
          SearchElements: maincityCar,
          CloseSelectionDropdown: false,
          blurVRM: valid,
        });
      }
    } else if (text.length === 0 || text.length < 3) {
      this.setState({
        CloseSelectionDropdown: true,
        SearchElements: '',
        blurVRM: false
      });
    }
    this.setState({ SelectedDropdownOption: newText });
  };

  textInputChange = async (value, data) => {
    var d = new Date();
    var minute = d.getMinutes();
    if (
      data.timeFlag &&
      (d.getHours() < 9 || ((d.getHours() >= 17 && minute >= 30) || (d.getHours() >= 18)))
    ) {
      this.setState({
        timeFlag: true,
        isVisible: true,
        timeMessage:
          data.serviceType === 'CANCEL_ECS_MANDATE' ? ALL_CONSTANTS.PROCESS_TIMING : ALL_CONSTANTS.PROCESS_TIMINGS,
      });
      return;
    }
    if (data.items.authenticationFlag === false && data.items.redirectionFlag) {
      if (Platform.OS == 'web') {
        window.open(data.items.redirectionUrl, target = "_blank");
      }
      else {
        Linking.openURL(data.items.redirectionUrl, target = "_blank");
      }
      return;
    }
    this.props.navigation.state.params = {};
    this.props.navigation.state.params.flow = value;
    this.props.navigation.state.params.serviceType = data.serviceType;
    this.props.navigation.state.params.servicename = data.optionname;
    this.props.navigation.state.params.menuname = data.menuname;
    this.props.navigation.state.params.serviceDynamic = data.dynamicStatus;
    this.props.navigation.state.params.menuType = data.dynamicMenuType;
    this.props.navigation.state.params.searchArray = this.state.searchArray;
    this.props.navigation.state.params.displayName = data.displayName;
    this.props.navigation.state.params.headerFlag = this.state.headerFlag;
    this.props.navigation.state.params.serviceId = data.serviceId;
    this.props.navigation.state.params.sourceType = this.state.sourceType;
    this.props.navigation.state.params.EncryptedData = this.state.EncryptedData;
    this.props.navigation.state.params.EncryptedSource = this.state.EncryptedSource;
    this.props.navigation.state.params.serviceId = data.serviceId;
    this.props.navigation.state.params.orderid = data.serviceId;
    this.props.navigation.state.params.item = data;

    sessionStorage.setItem('serviceId', data?.serviceId);

    if (Platform.OS === 'web') {
      sessionStorage.setItem('flag', 'true');
    } else {
      await AsyncStorage.setItem('flag', 'true');
    }
    this.props.navigation.state.params.account = 'false';
    this.props.navigation.state.params.mobile = 'true';
    this.props.navigation.state.params.firstpage = 'true';
    this.props.navigation.state.params.shortName1 = 'mob';
    this.props.navigation.state.params.shortName2 = 'pan';
    this.props.navigation.state.params.Optionselected2 = ALL_CONSTANTS.PAN_NUMBER_CONST;
    this.props.navigation.state.params.subHeading = data.displayName;
    if (data.items.popUpFlag) {
      this.setState({ isVisible: true, popUpFlag: true, uploadMessage: data.items.popUpMessage[0].note, hyperLinkText: data.items.popUpMessage[0].hyperlink }, () => {
      });
    }
    else if (this.state.headerFlag) {
      this.setState({ popUpFlag: false })
      this.props.navigation.navigate(
        'Verification',
        this.props.navigation.state.params
      );
    }
    else {
      this.props.navigation.navigate(
        'verifyUser',
        this.props.navigation.state.params
      );
    }

    if(data.serviceType==="UPDATE_FATCA"){
      this.setState({
        updateFatca:true
      })
    }
    else {
      this.setState({
        updateFatca:false
      })
    }
    this.setState({
      SelectedDropdownOption: value,
      CloseSelectionDropdown: true,
    });
  };

  find_dimesions = (layout) => {
    const { x, y, width, height } = layout;
    this.setState({ layoutheight: height });
    this.state.layoutheight = height;
  }

  find_dimesionsSidebar = (layout) => {
    const { x, y, width, height } = layout;
    this.setState({ sidebarlayoutheight: height });
    this.state.sidebarlayoutheight = height;
  }

  redirect = () => {
    this.timerHandle = setTimeout(() => {

      if (Platform.OS == 'web') {
        const pathName = window.location.pathname;
        const domainName = window.location.origin;

        const path = [
          ALL_CONSTANTS.OTHERURL_PATH
        ];
        let updatedPath = pathName.substr(1, pathName.lastIndexOf('/'));
        if (path.includes(pathName)) {
          window.location.href = `${domainName}${pathName}`;

        } else {
          window.location.href = `${domainName}/servicing/index.html`;
        }
      } else {
        window.location.href = `${domainName}/servicing/index.html`;
        //props.navigation.navigate('HomePage');
      }
      window.location.href = `${domainName}/servicing/index.html`;
      this.timerHandle = 0;


    }, 8000);
  };
  onIdle = async () => {
    if (!this.state.headerFlag) {
      this.props.navigation.navigate(
        'sessionExipry',
        this.props.navigation.state.params
      );
    } else {
      return
    }
  };

  render() {
    const { measure } = this.props;
    const windowHeight = this.state.windowHeight
    const sidebarlayoutheight = this.state.sidebarlayoutheight
    const sidebarHeight = windowHeight && sidebarlayoutheight ?
      windowHeight - sidebarlayoutheight : 'auto'
    const layoutheight = this.state.layoutheight
    return (
      <View
        style={[
          styles.HomescreenMainView,
          styles[getResponsiveStyle('HomescreenMainView', measure)]
        ]}
      >
        <IdleTimer
          ref={ref => {
            this.idleTimer = ref;
          }}
          element={document}
          onIdle={this.onIdle}
          debounce={APP.DEBOUNCE}
          timeout={60000 * 3}
        />
         <Modal
            isVisible={this.state.isVisible}
            measure={measure}>
            <View style={[ 
              this.state.updateFatca 
              ? styles.fatcaModalView: 
              styles.modalView,
            styles[getResponsiveStyle(
                this.state.updateFatca 
                ? 'fatcaModalView'
                :'modalView', measure)]]}>
              <View style={[
                this.state.updateFatca 
                ? styles.fatcaModalViewStyle
                : styles.ModalViewStyle,
                styles[getResponsiveStyle( 
                  this.state.updateFatca 
                  ? 'fatcaModalViewStyle'
                  : 'ModalViewStyle', measure)]
              ]}>
                <View
                  style={[
                    this.state.updateFatca 
                  ? styles.fatcamodalDropdownStyle
                   : styles.modalDropdownStyle,
                  styles[getResponsiveStyle('modalDropdownStyle', measure)]]}
                >
                  <TouchableOpacity 
                  //TO-DO ===> To be change onClick->onPress for mobilse application
                  onClick={() => this.onCancel()}>
                    <Image
                      style={[styles.modalCancel,
                      styles[getResponsiveStyle('modalCancel', measure)]]}
                      source={require('../../assets/images/cancel.png')}
                    />
                  </TouchableOpacity>
                </View>
                
                {
                  this.state.timeFlag ?
                    <Text
                      style={[
                        styles.declarText,
                        styles[getResponsiveStyle('declarText', measure)],
                      ]}
                    >
                      {this.state.timeMessage}
                    </Text> : null
                }
                <View style={[ 
                  this.state.updateFatca 
                  ? styles.fatcaView
                  : null]}>
                {this.state.popUpFlag ?
                  this.state.uploadMessage && this.state.uploadMessage.map((data,idx) => {
                      if (data.includes('EXTERNAL_LINK')) {
                      let num = Number(data.charAt(data.length - 1));
                      return (
                        this.state.hyperLinkText[num - 1].link ?
                        <a
                        href={this.state.hyperLinkText[num - 1].link}
                        target={"_blank"}
                        ellipsizeMode="tail"
                        style={{
                          alignItems: 'flex-start',
                          padding: 2,
                          marginLeft: 40,
                          justifyContent: 'flex-start',
                          textAlign: 'flex-start',
                          cursor: 'pointer',
                          listStyle: 'disc outside none',
                          fontSize:"14px",
                          display: 'list-item',
                          color: "#337ab7",
                          fontFamily: 'Mulish'
                        }}
                      >
                            {this.state.hyperLinkText[num - 1].linktext}
                          </a>
                          :
                          <p
                            style={{
                              alignItems: 'flex-start',
                              padding: 2,
                              marginLeft: 40,
                              justifyContent: 'flex-start',
                              textAlign: 'flex-start',
                              color: '#000000',
                              listStyle: 'disc outside none',
                              display: 'list-item'
                            }}
                          >
                            {this.state.hyperLinkText[num - 1].linktext}</p>
                      )
                    }   else if (data.includes('FATCA_LINK')) {
                          let num = Number(data.charAt(data.length - 1));
                      return (
                        this.state.hyperLinkText[num - 1].link ?
                        <a
                        href={this.state.hyperLinkText[num - 1].link}
                        target={"_blank"}
                        style={{
                                marginLeft:40,
                                display: 'list-item',
                                fontFamily:"mulish",
                                fontSize: 16
                              }}
                      >
                        {this.state.hyperLinkText[num - 1].linktext}
                      </a>
                      :
                      <p style={{ 
                                  marginLeft:40, 
                                  display: 'list-item',
                                  fontFamily:"mulish",
                                  fontSize: 16
                                }}>
                        {this.state.hyperLinkText[num - 1].linktext}
                      </p>
                          )}
                    else {
                      return (
                        <Text
                          style={[
                            styles.declarText,
                            styles[getResponsiveStyle('declarText', measure)],
                          ]}
                        >
                          {this.state.timeFlag
                            ? this.state.timeMessage
                           : idx<=7 ?<Text>
                              <Text>{data}</Text>
                              {(idx===7 && !this.state.isReadMore)?<Text  style={[
                                  styles.modaldeclarText,
                                  styles[getResponsiveStyle('modaldeclarText', measure)],
                                ]} onPress={this.toggleReadmore}> {' '}Read more</Text>:null} 
                              </Text>
                              :this.state.isReadMore?<View>
                                <Text>{data}</Text>
                                {idx===11?<Text  style={[
                                  styles.modaldeclarText,
                                  styles[getResponsiveStyle('modaldeclarText', measure)],
                                ]} onPress={this.toggleReadmore}>Read Less</Text>:null}
                              </View>:null}
                        </Text>
                      )
                    }
                    }) : <Text
                    style={[
                      styles.declarText,
                      styles[getResponsiveStyle('declarText', measure)],
                    ]}
                  >
                    {this.state.timeFlag
                      ? this.state.timeMessage
                      : this.state.popUpFlag ? data : this.state.uploadMessage}
                  </Text>
                }
                </View>

                <View style={[styles.agreeButtonView,
                styles[getResponsiveStyle('agreeButtonView', measure)],
                ]}>
                  <TouchableOpacity
                    //TO-DO ===> To be change onClick->onPress to run on React native (mobile application)
                    onClick={() => this.onCancel()}
                    style={[
                      styles.agreeButton,
                      {
                        backgroundColor: this.state.disableButton
                          ? '#808080'
                          : '#e77817',
                      },
                      styles[getResponsiveStyle('agreeButton', measure)],
                    ]}
                  >
                    <Text
                      style={[
                        styles.textStyle,
                        styles.textStylePadding,
                        styles[getResponsiveStyle('textStylePadding', measure)],
                        styles[getResponsiveStyle('textStyle', measure)],
                      ]}
                    >
                      {ALL_CONSTANTS.CANCEL}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    //TO-DO ===> To be change onClick->onPress to run on React native (mobile application)
                    onClick={() => this.onAgree()}
                    style={[
                      styles.agreeButton,
                      {
                        backgroundColor: this.state.disableButton
                          ? '#808080'
                          : '#e77817',
                      },
                      styles[getResponsiveStyle('agreeButton', measure)],
                    ]}
                  >
                    <Text
                      style={[
                        styles.textStyle,
                        styles.textStylePadding,
                        styles[getResponsiveStyle('textStylePadding', measure)],
                        styles[getResponsiveStyle('textStyle', measure)],
                      ]}
                    >
                      {this.state.timeFlag ? ALL_CONSTANTS.OK : ALL_CONSTANTS.CONTINUE_TEXT}
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </Modal>
        {this.state.headerFlag ?
          (
            <View onLayout={(event) => { this.find_dimesionsSidebar(event.nativeEvent.layout) }}
              style={styles.nav}>
              {measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI' ? (
                <TopMobileNav
                  {...this.props}
                  Dontshow_Searchoption={true}
                  ServiceRequests={this.state.ServiceRequests}
                  RendermenuBar={this.RendermenuBar}
                  openMobilelist={this.state.openMobilelist}
                  homeScreen={this.state.homeScreen}
                  headerFlag={this.state.headerFlag}
                  textInputChange={this.textInputChange}
                  SearchElements={this.state.SearchElements}
                  searchOptionChange={this.searchOptionChange}
                  OnServiceRequestsButtonPress={this.OnServiceRequestsButtonPress}
                />
              ) :
                this.state.bitlyStatus ? null : (
                  <TopNav
                    {...this.props}
                    textInputChange={this.textInputChange}
                    isSearch={this.state.isSearch}
                    Dontshow_Searchoption={false}
                    homeScreen={this.state.homeScreen}
                    showip={true}
                    headerFlag={this.state.headerFlag}
                    CloseSelectionDropdown={this.state.CloseSelectionDropdown}
                    SelectedDropdownOption={this.state.SelectedDropdownOption}
                    SearchElements={this.state.SearchElements}
                    searchOptionChange={this.searchOptionChange}
                    ServiceRequests={this.state.ServiceRequests}
                    OnServiceRequestsButtonPress={this.OnServiceRequestsButtonPress}
                  />
                )
              }
            </View>) : (<View></View>)}
        <ScrollView
          style={
            Platform.OS === 'web'
              ? isFirefox
                ? this.state.headerFlag
                  ? [
                    styles.homescreenMobileScrollViewMarginFirefox,
                    styles[
                    getResponsiveStyle(
                      'homescreenMobileScrollViewMarginFirefox',
                      measure
                    )
                    ]
                  ]
                  : [
                    styles.homescreenMobileScrollViewMarginFirefoxheadernone,
                    styles[
                    getResponsiveStyle(
                      'homescreenMobileScrollViewMarginFirefoxheadernone',
                      measure
                    )
                    ]
                  ]
                : this.state.headerFlag
                  ? [this.state.hidemenu == true ?
                    [styles.homescreenMobileScrollViewMarginProfile,
                    styles[
                    getResponsiveStyle(
                      'homescreenMobileScrollViewMarginProfile',
                      measure
                    )
                    ]] : styles.homescreenMobileScrollViewMargin,
                  styles[
                  getResponsiveStyle(
                    'homescreenMobileScrollViewMargin',
                    measure
                  )
                  ]
                  ]
                  : [
                    styles.homescreenMobileScrollViewMarginheadernone,
                    styles[
                    getResponsiveStyle(
                      'homescreenMobileScrollViewMarginheadernone',
                      measure
                    )
                    ]
                  ]
              : { marginBottom: '10%' }
          }
        >
          {/* remove this web when search becomes proper in mobile */}
          {Platform.OS == 'web' &&
            (measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') ? (
            <Topsection
              {...this.props}
              isSearch={this.state.isSearch}
              CloseSelectionDropdown={this.state.CloseSelectionDropdown}
              SelectedDropdownOption={this.state.SelectedDropdownOption}
              textInputChange={this.textInputChange}
              headerFlag={this.state.headerFlag}
              SearchElements={this.state.SearchElements}
              searchOptionChange={this.searchOptionChange}
              ServiceRequests={this.state.ServiceRequests}
              OnServiceRequestsButtonPress={this.OnServiceRequestsButtonPress}
            />
          ) : null}

          {measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI' ? (
            <View
              style={[
                styles.homescreenMobileMargin,
                { zIndex: -9, },
                styles[getResponsiveStyle('homescreenMobileMargin', measure)]
              ]}
            >
              {this.state.serviceData.length != 0 ? (
                <View
                  style={
                    this.state.machine != false ? [
                      styles.Homescreensplit2backgroundcolorATM,
                      styles[
                      getResponsiveStyle(
                        'Homescreensplit2backgroundcolorATM',
                        measure
                      )
                      ]
                    ] :
                      [styles.Homescreensplit2backgroundcolor,
                      styles[
                      getResponsiveStyle(
                        'Homescreensplit2backgroundcolor',
                        measure
                      )
                      ]]}
                >
                  <Text
                    style={[
                      styles.textHeadingInLayout,
                      styles[
                      getResponsiveStyle('textHeadingInLayout', measure)
                      ]
                    ]}
                  >
                    {this.state.Menuselected}
                  </Text>
                  {this.state.Menuselected === 'Profile Update Requests' ?
                    <View style={[
                      styles.prifletextvw,
                      styles[getResponsiveStyle('prifletextvw', measure)]
                    ]}>
                      <Text
                        style={[
                          styles.ProfileserviceText, { color: '#101d6c' },
                          styles[getResponsiveStyle('ProfileserviceText', measure)]
                        ]}
                      >
                        Profile details will be updated across your bank relationship
                      </Text>
                    </View>
                    : null}
                  <FlatList
                    data={formatData(this.state.serviceData, 2)}
                    renderItem={this.renderItem}
                    numColumns={2}
                  />
                  {this.state.data.length > this.state.perPage ? (
                    <View
                      style={[
                        styles.flatMobView,
                        styles[getResponsiveStyle('flatMobView', measure)]
                      ]}
                    >
                      <View
                        style={[
                          styles.flatListmobView,
                          styles[getResponsiveStyle('flatListmobView', measure)]
                        ]}
                      >
                        {measure === 'MDPI' ||
                          measure === 'LDPI' ||
                          measure === 'HDPI' ||
                          Platform.OS !== 'web' ? (
                          <View style={{ flexDirection: 'row' }}>
                            {this.state.selectedPage > 1 ? (
                              <View
                                style={{
                                  flex: 1,
                                  justifyContent: 'center',
                                  alignItems: 'flex-start'
                                }}
                              >
                                <TouchableOpacity
                                  style={{
                                    paddingHorizontal: '22%',
                                    paddingVertical: '12%',
                                    borderRadius: 8,
                                    backgroundColor:
                                      Platform.OS == 'web' ? null : '#e2e2e2',
                                    background:
                                      'linear-gradient(to bottom, #f58e21, #ef6812 )'
                                  }}
                                  onPress={() => this.viewless()}
                                >
                                  {Platform.OS == 'web' ? (
                                    <Image
                                      style={{
                                        height: 10,
                                        width: 10
                                      }}
                                      source={require('../../assets/images/whiteleftarrow.png')}
                                    />
                                  ) : (
                                    <Image
                                      style={{
                                        height: 10,
                                        width: 10
                                      }}
                                      source={require('../../assets/images/whiteleftarrow.png')}
                                    />
                                  )}
                                </TouchableOpacity>
                              </View>
                            ) : (
                              <View style={{ flex: 1 }} />
                            )}
                            <View
                              style={{
                                flex: 1,
                                justifyContent: 'center',
                                alignItems: 'center'
                              }}
                            >
                              <FlatList
                                data={this.state.pageArray}
                                renderItem={this.renderCircle}
                                numColumns={this.state.pageCount}
                                extraData={this.state.refresh}
                                key={this.state.pageCount}
                              />
                            </View>
                            {this.state.selectedPage >= this.state.pageCount ? (
                              <View style={{ flex: 1 }} />
                            ) : (
                              <View
                                style={{
                                  flex: 1,
                                  justifyContent: 'center',
                                  alignItems: 'flex-end'
                                }}
                                onPress={() => this.viewMore()}
                              >
                                <TouchableOpacity
                                  style={{
                                    paddingHorizontal: '22%',
                                    paddingVertical: '12%',
                                    borderRadius: 8,
                                    backgroundColor:
                                      Platform.OS == 'web' ? null : '#e2e2e2',
                                    background:
                                      'linear-gradient(to bottom, #f58e21, #ef6812)'
                                  }}
                                  onPress={() => this.viewMore()}
                                >
                                  {Platform.OS == 'web' ? (
                                    <Image
                                      style={{
                                        height: 10,
                                        width: 10,
                                        borderRadius: 5
                                      }}
                                      source={require('../../assets/images/whiterightarrow.png')}
                                    />
                                  ) : (
                                    <Image
                                      style={{
                                        height: 10,
                                        width: 10,
                                        borderRadius: 5
                                      }}
                                      source={require('../../assets/images/whiterightarrow.png')}
                                    />
                                  )}
                                </TouchableOpacity>
                              </View>
                            )}
                          </View>
                        ) : (
                          <FlatList
                            data={this.state.pageArray}
                            renderItem={this.renderCircle}
                            numColumns={this.state.pageCount}
                            extraData={this.state.refresh}
                            key={this.state.pageCount}
                          />
                        )}
                      </View>
                    </View>
                  ) : null}
                  {Platform.OS !== 'web' &&
                    this.state.data.length > this.state.perPage ? (
                    <View style={{ flexDirection: 'row' }}>
                      <View
                        style={[
                          styles.preView,
                          styles[getResponsiveStyle('preView', measure)]
                        ]}
                      >
                        {Platform.OS == 'web' && this.state.selectedPage > 1 ? (
                          <TouchableOpacity
                            onPress={() => this.viewless()}
                            style={[
                              styles.prevImageView,
                              styles[
                              getResponsiveStyle('prevImageView', measure)
                              ]
                            ]}
                          >
                            <Image
                              style={{ height: 10, width: 10 }}
                              source={require('../../assets/images/whiteleftarrow.png')}
                            />
                          </TouchableOpacity>
                        ) : null}
                      </View>

                      <View
                        style={[
                          styles.nextView,
                          styles[getResponsiveStyle('nextView', measure)]
                        ]}
                      >
                        {Platform.OS == 'web' &&
                          this.state.selectedPage <= this.state.pageCount ? (
                          <TouchableOpacity
                            onPress={() => this.viewMore()}
                            style={[
                              styles.nextImageView,
                              styles[
                              getResponsiveStyle('nextImageView', measure)
                              ]
                            ]}
                          >
                            <Image
                              style={{ height: 10, width: 10 }}
                              source={require('../../assets/images/whiterightarrow.png')}
                            />
                          </TouchableOpacity>
                        ) : null}
                      </View>
                    </View>
                  ) : null}
                  <View style={{ justifyContent: 'center', alignItems: 'center' }}><Text style={{ fontSize: 12 }}>Rel. Ver. 1.0</Text></View>
                </View>
              ) : (
                <View>
                  <View
                    style={[
                      styles.servieNotavailableView,
                      styles[
                      getResponsiveStyle('servieNotavailableView', measure)
                      ]
                    ]}
                  >
                    {Platform.OS != 'web' ?
                      <Image
                        style={[
                          styles.updatedImagestyle,
                          styles[getResponsiveStyle('updatedImagestyle', measure)]
                        ]}
                        source={require('../../assets/images/Loadinggif.gif')}
                      />
                      :
                      <Loader measure={measure}></Loader>
                    }

                    {/* <Image
                      style={[
                        styles.updatedImagestyle,
                        styles[getResponsiveStyle('updatedImagestyle', measure)]
                      ]}
                      source={require('../../assets/images/Loadinggif.gif')}
                    /> */}
                  </View>
                  <View>
                    <Text
                      style={[
                        styles.textHeading,
                        styles[getResponsiveStyle('textHeading', measure)]
                      ]}
                    >
                      {this.state.loader ? '' : this.state.bitlyStatus ? '' : 'Service not Available'}
                    </Text>
                  </View>
                </View>
              )}
            </View>
          ) : (
            <View
              style={
                this.state.blur
                  ? [
                    styles.isblur, { backgroundColor: '#fcebd6' },
                    styles[getResponsiveStyle('isblur', measure)]
                  ]
                  :
                  this.state.machine == true ? [
                    styles.isNotbluratm,
                    styles[getResponsiveStyle('isNotblur', measure)]
                  ] :
                    [
                      styles.isNotblur, { backgroundColor: this.state.serviceData.length != 0 ? '#fcebd6' : '' },
                      styles[getResponsiveStyle('isNotblur', measure)]
                    ]
              }
            >
              {!this.state.hidemenu ? (
                <View
                  style={
                    this.state.blur
                      ? null
                      : [
                        this.state.headerFlag ? styles.Homescreensplit : styles.HomescreensplitParams,
                        { height: sidebarHeight },
                        styles[getResponsiveStyle('Homescreensplit', measure)],
                        styles[getResponsiveStyle('HomescreensplitParams', measure)]
                      ]
                  }
                >

                  <Leftsidebar
                    {...this.props}
                    machine={this.state.machine}
                    menuload={this.state.menuload}
                    ServiceRequests={this.state.ServiceRequests}
                    headerFlag={this.state.headerFlag}
                    OnServiceRequestsButtonPress={
                      this.OnServiceRequestsButtonPress
                    }
                  />


                </View>
              ) : null}
              <View onLayout={(event) => { this.find_dimesions(event.nativeEvent.layout) }}
                style={this.state.hidemenu ? [
                  this.state.hidemenu == true ?
                    [styles.HomescreenhidemenuProfile,
                    styles[getResponsiveStyle('Homescreenhidemenu', measure)]] :
                    [styles.Homescreenhidemenu,
                    styles[getResponsiveStyle('Homescreenhidemenu', measure)]]
                ] : this.state.machine ? [
                  styles.Homescreensplit2atm,
                  { backgroundColor: this.state.serviceData.length != 0 ? '#fcebd6' : '' },
                  styles[getResponsiveStyle('Homescreensplit2', measure)
                  ]] :
                  [
                    this.state.headerFlag ? styles.Homescreensplit2 : styles.Homescreensplit2Params,
                    { backgroundColor: this.state.serviceData.length != 0 ? '#fcebd6' : '' },
                    styles[getResponsiveStyle('Homescreensplit2', measure)
                    ],
                    styles[getResponsiveStyle('Homescreensplit2Params', measure)
                    ]
                  ]
                }
              >
                {this.state.serviceData.length != 0 ? (
                  <View
                    style={
                      this.state.headerFlag ?
                        this.state.machine ?
                          [styles.Homescreensplit2backgroundcoloratm,
                          styles[
                          getResponsiveStyle(
                            'Homescreensplit2backgroundcoloratm',
                            measure
                          )
                          ]] : [
                            this.state.hidemenu == true ?
                              [styles.Homescreensplit2backgroundcolorProfile,
                              styles[
                              getResponsiveStyle(
                                'Homescreensplit2backgroundcolorProfile',
                                measure
                              )
                              ]] : isFirefox ? [styles.Homescreensplit2backgroundcolorFireFox, styles[
                                getResponsiveStyle(
                                  'Homescreensplit2backgroundcolorFireFox',
                                  measure
                                )
                              ]] :
                                styles.Homescreensplit2backgroundcolor,
                            { height: layoutheight },
                            styles[
                            getResponsiveStyle(
                              'Homescreensplit2backgroundcolor',
                              measure
                            )
                            ]] : [styles.Homescreensplit2backgroundcolorOther,
                            styles[
                            getResponsiveStyle(
                              'Homescreensplit2backgroundcolorOther',
                              measure
                            )
                            ]]
                    }
                  >
                    {this.state.headerFlag ? <View></View> : (
                      <View style={{ justifyContent: 'left', display: 'flex', flexDirection: 'row' }}>
                        <View style={
                          [
                            styles.TopsectionAutocompletestyleVRM,
                            styles[
                            getResponsiveStyle(
                              'TopsectionAutocompletestyleVRM',
                              measure
                            )
                            ],
                          ]
                        }
                        >

                          <TouchableOpacity >
                            <Image
                              style={{
                                width: 20,
                                height: 20,
                                marginRight: 10,
                              }}
                              resizeMode='contain'
                              source={require('../../assets/images/searchicon.png')}
                            />
                          </TouchableOpacity>
                          <View style={{width:'96%'}}>
                          <Autocomplete
                            ref={this.searchRef}
                            startWithSearchIcon={true}
                            measure={measure}
                            autoCapitalize='none'
                            searchIcon={true}
                            autoCorrect={false}
                            machine={this.props.machine}
                            searchClick={data => this.searchClick(data)}
                            hideResults={this.props.CloseSelectionDropdown}
                            inputContainerStyle={{
                              borderBottomWidth: null,
                              borderBottomColor: 'transparent',
                              width: measure === 'LAPTOP' ? 620 : 350
                            }}
                            style={[
                              styles.TopsectionAutocompletestyleSearchBar,
                              styles[
                              getResponsiveStyle(
                                'TopsectionAutocompletestyleSearchBar',
                                measure
                              )
                              ],
                            ]}
                            data={this.state.SearchElements}
                            value={this.state.SelectedDropdownOption}
                            onChangeText={text => {
                              this.searchOptionChangeVRM(text);
                            }}
                            placeholder={'Search for service request...'}
                            renderItem={val => (
                              <TouchableOpacity
                                style={[
                                  styles.TopsectionAutocompleteButtonstyleSearchBar,
                                  {},
                                  styles[
                                  getResponsiveStyle(
                                    'TopsectionAutocompleteButtonstyleSearchBar',
                                    measure
                                  )
                                  ]
                                ]}
                                onPress={() => {
                                  this.textInputChange(
                                    val.optionname.toUpperCase(),
                                    val
                                  );
                                }}
                              >
                                {measure === 'XXHDPI' ? <View></View> : <Image
                                  resizeMode='contain'
                                  source={val.images}
                                  style={{
                                    width: 25,
                                    height: 25,
                                    marginLeft: 5
                                  }}
                                />}
                                <Text
                                  style={[
                                    styles.TopsectionAutocompletemenutextstyleSearchBar,

                                    styles[
                                    getResponsiveStyle(
                                      'TopsectionAutocompletemenutextstyleSearchBar',
                                      measure
                                    )
                                    ]
                                  ]}
                                >
                                  {toTitleCase(val.dynamicMenuType)}
                                </Text>
                                <Text
                                  style={[
                                    styles.TopsectionAutocompleteServicetextstyleSearchBar,
                                    styles[
                                    getResponsiveStyle(
                                      'TopsectionAutocompleteServicetextstyleSearchBar',
                                      measure
                                    )
                                    ]
                                  ]}
                                >
                                  {" - "}{val.optionname}
                                </Text>
                              </TouchableOpacity>
                            )}
                          />
                        </View>
                      </View>
                      </View>
                    )}
                    <Text
                      style={
                        this.state.machine != false
                          ? [
                            styles.textHeadingInLayoutATM,
                            styles[
                            getResponsiveStyle(
                              'textHeadingInLayoutATM',
                              measure
                            )
                            ],
                          ]
                          : this.state.hidemenu == true
                            ? [
                              styles.textHeadingInLayouthidemenu,
                              styles[getResponsiveStyle(
                                'textHeadingInLayouthidemenu', measure
                              )
                              ],
                            ]
                            : [
                              styles.textHeadingInLayout,
                              styles[
                              getResponsiveStyle(
                                'textHeadingInLayout',
                                measure
                              )
                              ],
                            ]
                      }
                    >
                      {this.state.Menuselected}
                    </Text>
                    {this.state.Menuselected === 'Profile Update Requests' ? (
                      <View
                        style={this.state.blurVRM ? {
                          zIndex: -999,
                          marginLeft: '1%'
                        } : [
                          styles.prifletextvw,
                          styles[getResponsiveStyle('prifletextvw', measure)],
                        ]}>
                        <Text
                          style={
                            // this.state.blurVRM ?{
                            //   //display:'none'
                            // }:
                            [
                              styles.ProfileserviceText,
                              { color: '#101d6c', fontWeight:"bold" },
                              styles[
                              getResponsiveStyle('ProfileserviceText', measure)
                              ]
                            ]}
                        >
                          Profile details will be updated across your bank relationship
                        </Text>
                      </View>
                    ) : null}
                    <View
                      style={this.state.blurVRM ?
                        {
                          zIndex: -9999999,
                          opacity: 1
                        } :
                        { flex: this.state.machine != false ? null : 4 }
                      }
                    >
                      {this.state.Menuselected ===
                        'Other Service Requests' ? null : (
                        <FlatList
                          data={formatData(
                            this.state.serviceData,
                            this.state.machine != false
                              ? 3
                              : measure === 'XXHDPI'
                                ? 4
                                : 5
                          )}
                          renderItem={this.renderItem}
                          numColumns={
                            this.state.machine != false
                              ? 3
                              : measure === 'XXHDPI'
                                ? 4
                                : 5
                          }
                          key={
                            this.state.machine != false
                              ? 3
                              : measure === 'XXHDPI'
                                ? 4
                                : 5
                          }
                        />
                      )}
                    </View>
                    {this.state.Menuselected != 'Other Service Requests' ? (
                      this.state.data.length > this.state.perPage ? (
                        <View style={{ flexDirection: 'row', flex: this.state.machine != false ? null : 0.8 }}>
                          <View
                            style={[
                              styles.preView,
                              styles[getResponsiveStyle('preView', measure)]
                            ]}
                          >
                            {this.state.selectedPage > 1 ? (
                              <TouchableOpacity
                                onPress={() => this.viewless()}
                                style={[
                                  styles.prevImageView,
                                  {
                                    background:
                                      'linear-gradient(to bottom, #f58e21, #ef6812 )',
                                    paddingVertical: '8%',
                                    paddingHorizontal: '20%'
                                  },
                                  styles[
                                  getResponsiveStyle('prevImageView', measure)
                                  ]
                                ]}
                              >
                                <Image
                                  style={{ width: 14, height: 21 }}
                                  source={require('../../assets/images/whiteleftarrow.png')}
                                />
                              </TouchableOpacity>
                            ) : null}
                          </View>
                          <View
                            style={{
                              flex: this.state.machine != false ? null : 2,
                              justifyContent: 'center',
                              padding: '2%'
                            }}
                          >
                            <View
                              style={this.state.blurVRM ?
                                { display: 'none' } : {
                                  width: '100%',
                                  alignItems: 'center',
                                  paddingTop: '2%'
                                }}
                            >
                              <FlatList
                                data={this.state.pageArray}
                                renderItem={this.renderCircle}
                                numColumns={this.state.pageCount}
                                extraData={this.state.refresh}
                                key={this.state.pageCount}
                              />
                            </View>
                          </View>
                          <View
                            style={this.state.blurVRM ?
                              { display: 'none' } : [
                                styles.nextView,
                                styles[getResponsiveStyle('nextView', measure)],
                              ]}
                          >
                            {this.state.selectedPage >=
                              this.state.pageCount ? null : (
                              <TouchableOpacity
                                onPress={() => this.viewMore()}
                                style={[
                                  styles.nextImageView,
                                  {
                                    background:
                                      'linear-gradient(to bottom, #f58e21, #ef6812)',
                                    paddingVertical: '8%',
                                    paddingHorizontal: '20%'
                                  },
                                  styles[
                                  getResponsiveStyle('nextImageView', measure)
                                  ]
                                ]}
                              >
                                <Image
                                  style={{ width: 14, height: 21 }}
                                  source={require('../../assets/images/whiterightarrow.png')}
                                />
                              </TouchableOpacity>
                            )}
                          </View>
                        </View>
                      ) : null) : null}
                    <View style={{ justifyContent: 'center', alignItems: 'center' }}><Text style={{ fontSize: 12 }}>Rel. Ver. 1.0</Text></View>
                  </View>
                ) : (
                  <View>
                    {Platform.OS != 'web' ? (
                      <Image
                        style={[
                          styles.updatedImagestyle,
                          styles[getResponsiveStyle('updatedImagestyle', measure)]
                        ]}
                        source={require('../../assets/images/Loadinggif.gif')}
                      />
                    ) :
                      this.state.data.length === 0 ? null :
                        <Loader measure={measure}></Loader>
                    }
                    {/* <Image
                        style={[
                          styles.updatedImagestyle,
                          styles[
                          getResponsiveStyle('updatedImagestyle', measure)
                          ]
                        ]}
                        source={require('../../assets/images//spinner.gif')}
                      /> */}
                    {/* </View> */}
                    <View>
                      <Text
                        style={[
                          styles.textHeading,
                          styles[getResponsiveStyle('textHeading', measure)]
                        ]}
                      >
                        {this.state.loader ? '' : this.state.bitlyStatus ? '' : 'Service not Available'}
                      </Text>
                    </View>
                  </View>
                )}
                {/* {this.state.menuType === 'BANK' &&
                this.state.menuType === 'ATM' ? (
                  <View
                    style={[
                      styles.serviceContent,
                      styles[getResponsiveStyle('serviceContent', measure)]
                    ]}
                  >
                    {Platform.OS === 'web' ? (
                      <View
                        style={[
                          styles.cashButtonView,
                          styles[getResponsiveStyle('cashButtonView', measure)]
                        ]}
                      >
                        <TouchableOpacity
                          style={[
                            styles.cardLessButton,
                            styles[
                              getResponsiveStyle('cardLessButton', measure)
                            ]
                          ]}
                        >
                          <Text
                            style={[
                              styles.newserviceText,
                              styles[
                                getResponsiveStyle('newserviceText', measure)
                              ]
                            ]}
                          >
                            Card-less Cash withdrawal
                          </Text>
                        </TouchableOpacity>
                      </View>
                    ) : null}
                  </View>
                ) : null} */}
              </View>
            </View>
          )}
        </ScrollView>
      </View>
    );
  }
}

HomeScreen.contextType = AppConsumer;

export default hocComponentFetcherWithLoader()(HomeScreen);
